import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, AfterViewInit } from "@angular/core";
import { MenudetailService, MenuTab } from "./menuDetail.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { Location } from "@angular/common";
import { CoreCOMService } from "../../services/com.service";
import { floatingText } from "../../shared/animation/component.animation";
import Utils from "../../shared/utils";
import { EMenuService } from "../../services/emenu.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import * as _ from "lodash";
import { ClientType } from "../../services/com/comEnvironmentClient";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { IBenefitCacheEntry, ProductConfiguration, ProductConfigurationExtra, WebShopMode } from "../../services/IWebShopService";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { TrackingManager } from "../../services/tracking/tracking-manager";
import { WebShopService } from "../../services/webShop.service";
import { AGBConfirmationDialogResult, AnounceModalResult, ContentType, ContinueShoppingAction, ImageOrientation, ItemTagType, SnackBarMessageType, TranslationContentType, VoucherServiceType, YourAPPProductType } from "../../shared/contentTypes";
import { BaseUnit, DepositView, ItemTagViewModel, MenuSettingsDataModel2, MenuSettingViewModel, ProductDataModel4, ProductDetailsDataModel3, ProductDetailViewModel, ProductExtraItemViewModel, RatingViewModel, UsingType, WebshopSettingsDataModel2 } from "../../shared/models";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { AccessibilityWebShopService } from "../../services/accessibilityWebShop.service";
import { ContinueShoppingDialogComponent, AnnounceDialogComponent, RatingDialogComponent, ExtraAdditionalInfoDialogComponent, RemoteGroupContinueOrderDialogComponent, AGBConfirmationDialogComponent, TermDialogComponent } from "../../modalDialogs";
import { CoreLanguageManager } from "../../services/ILanguageManager";
import { environment } from "../../../../environments/environment";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { take } from "rxjs/operators";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IItemConfigurationData, IExtraItemConfig, IItemConfig, IContinueShoppingDialogResult } from "./menuDetail.facade";
import { OrderStatus, OrderType, req_Order } from "../../services/IInHouseOrderService";
import { BenefitRedemptionService } from "../../services/benefitRedemption.service";
import { AppErrorCode } from "../../shared/enums/ErrorCodes.enum";
import { CouponRedemptionService } from "../../services/couponRedemption.service";

class ChoiceExtra {
  public items: ChoiceExtraItem[] = [];
  public sortNr: number;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public min: number = 0;
  public max: number = 1; // -1 = Infinite; 0 = not selectable?
  public count: number = 0;
  public showUpToNItems: number = 5;
  /** Anzahl an selektierbaren Extras */
  public countOfExtraOptions: number = 0;
  /** Ob der Nutzer eine tatsächliche Wahl hat*/
  public hasNoChoice: boolean = false;
  public subIndex: number;
  public hasImage: boolean;
}

/** hier werden die infos zu den extras/subextras geholt */
class ChoiceExtraItem {
  public get id(): number {
    return this._model.id;
  }
  public get product_id(): number {
    return this._model.product_id;
  }
  public get label(): string {
    const _label = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.titleEN) ? this._model.titleDE : this._model.titleEN;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.ArticleExtra_Artikel_Name, this._model.id, _label);
    }
    else {
      return _label;
    }
  }
  /** grund preis mit pfand, wenn inklisive */
  public get price(): number {
    const price = this.isBenefitItem() ? 0 : this._model.price;
    return this.includeDeposit ? price + this._model.deposit : price;
  }

  private isBenefitItem(): boolean {
    return this._isBenefitCallback ? this._isBenefitCallback() : false;
  }
  public get deposit(): number {
    return this._model.deposit;
  }
  public get sortNr(): number {
    return this._model.order;
  }
  public get subIndex(): number {
    return this._model.subIndex;
  }
  /** has image ohne product returnt false  */
  public get hasImage(): boolean {
    return this._product && this._product.last_image_update_at_hms > -1;
  }
  /** imageUrl ist leer ohne product */
  public get imageUrl(): string {
    if (this.hasImage)
      return ContentType.sub_Product + "/" + this._product.product_id + "_photo_" + ImageOrientation.Landscape + "/" + this._product.last_image_update_at_ymd + "/" + this._product.last_image_update_at_hms;
    else
      return ""
  }
  public count: number = 0;
  public max: number = 1;
  public expanded: boolean = false;
  public isAvailable: boolean = true;
  public includeDeposit: boolean = true;
  public subExtras: ChoiceExtraItem[] = [];
  public basUnitId: BaseUnit;
  /** hasAdditionalInfo wird asynchrone ermittelt und kann erst zu einem Späteren Zeitpunkt auf true sich ändern */
  public get hasAdditionalInfo$(): Observable<boolean> {
    return this._model.hasAdditionalInfo$;
  }
  public get displayExtraBasePrice$(): Observable<boolean> {
    return this._model.displayExtraBasePrice$;
  }

  /** Artikel Details Model vom Extra, wird nur gefüllt, wenn hasAdditionalInfo true ist */
  public get productDetails(): ProductDetailsDataModel3 {
    return this._model.productDetails;
  }
  /** MenüSettings, wird nur gefüllt, wenn hasAdditionalInfo true ist */
  public get menuSetting(): MenuSettingsDataModel2 {
    return this._model.menuSetting;
  }

  private _model: ProductExtraItemViewModel;
  private _product: ProductDataModel4;
  private _isBenefitCallback: () => boolean;

  /**
   * @param model
   * @param product product vom extraitem wird benötigt, wenn ein bild dargestellt werden soll
   */
  public constructor(model: ProductExtraItemViewModel, product: ProductDataModel4) {
    this._model = model;
    this._product = product;
  }

  public setIsBenefitCallback(callback: () => boolean): void {
    this._isBenefitCallback = callback;
  }
}

@Component({
  selector: "menudetail",
  templateUrl: "./menuDetail.component.html",
  styleUrls: ["./menuDetail.component.scss"],
  providers: [MenudetailService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [floatingText]
})
export class MenuDetailComponent implements OnInit, AfterViewInit, OnDestroy {

  private _langSubscriber: Subscription;
  private _shippingCartSubscriber: Subscription;
  private _viewTypeSubscription: Subscription;
  private _menuSettingSubscriber: Subscription;
  private _productSubscriber: Subscription;

  public WebShopMode = WebShopMode;
  public UsingType = UsingType;
  private productId: number;
  private locationId: number;
  private webshopSettings: WebshopSettingsDataModel2;
  // set animation movement
  private activeItemGroupId: number;
  public isBenefit: boolean = false;

  public totalPrice: number;
  public deposit: number;
  public choiceExtras: ChoiceExtra[] = [];
  public hasData: boolean = true; // check if there is data for this page;
  public currentProductSettingIndex: number;
  public pageTitle: string;
  public productDetailViewModel: ProductDetailViewModel = new ProductDetailViewModel();
  public isOnline: boolean = false;
  public contentType = ContentType;
  public isEMenu: boolean;
  public serviceId: WebShopMode;
  public hasImage: boolean;
  public hasDescriprion: boolean = false;
  public includeDeposit: boolean = true;

  public variablePriceInputValue = "";
  public currencySymbol = "NO CURRENCY FOUND";
  public isAvailable = false;
  /** gewählter typ des webgutschein verkaufs */
  public voucherService: VoucherServiceType = null;
  public voucherServiceType = VoucherServiceType;
  private useBrowserHistory: boolean;
  public itemTags: ItemTagViewModel[];
  public isItemTagEnabled: boolean = false;
  public itemTagType: ItemTagType;
  public tagType = ItemTagType;

  public emptybasket: boolean = true;
  public itemsInBasket: number = 0;

  public showBuying: boolean = false;
  public headerGroupAdditives: MenuSettingViewModel;
  public headerGroupAllergies: MenuSettingViewModel;
  public headerGroupCO2: MenuSettingViewModel;

  private benfitCostPoints = 0;

  private _buyAmount: number = 1;
  public get buyAmount(): number {
    return this._buyAmount;
  }

  /** Manual entering buyAmount in input field */
  public set buyAmount(amount: number) {
    const me = this;
    if (me._isOpenedFromCoupon) {
      me._buyAmount = 1;
      return;
    }
    const numericValue = parseInt(amount.toString(), 10);
    if (!isNaN(numericValue)) {
      if (numericValue < 1) {
        me._buyAmount = 1;
      } else if (numericValue > 99) {
        me._buyAmount = 99;
      } else {
        me._buyAmount = numericValue;
      }
    }
  }

  public annotationTitle: string = "";
  public annotationPlaceholder: string = "";
  public use_item_annotation: boolean = false;
  public itemAnnotationText: string = "";

  /** A coupon redeems exactly one item. */
  public get isAmountLocked(): boolean {
    const me = this;
    return me._isOpenedFromCoupon;
  }

  increaseAmount() {
    if (this.isAmountLocked) {
      return;
    }
    const updatedAmount = this.buyAmount + 1;
    this.buyAmount = updatedAmount;
  }

  decreaseAmount() {
    this.buyAmount = this.buyAmount - 1;
  }

  public onBlurAmount() {
    const me = this;
    me.setWebView();
  }

  public onFocusAmount(event: FocusEvent) {
    (event.target as HTMLInputElement).select();
  }


  private get isRemoteOrderGroup() {
    return this.serviceId === WebShopMode.PickupGroup || this.serviceId === WebShopMode.DeliveryGroup;
  }

  private get isInHouseGroupOrder() {
    const inHouseOrder = this._webShopService.getServiceMode() === WebShopMode.OrderToTable;
    return inHouseOrder ? this._inHouseOrderService.UiData.isGroup : false;
  }

  //Small view starts at widths below 785 px
  public isSmallView: boolean = false;

  private _isOpenedFromCoupon: boolean = false;
  /** Marks a basket-coupon-line re-open; cleared after the first read so a later normal visit is never locked. */
  private _isOpenedFromBasketCouponRow: boolean = false;
  private _isCouponAttachedToCart: boolean = false;
  /** Guards addProductToBasket against a second concurrent tap merging a duplicate coupon line into the cart. */
  private _isAddingProductToBasket: boolean = false;

  constructor(private _menuDetailService: MenudetailService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _activatedRoute: ActivatedRoute
    , private _snackBarService: SnackBarService
    , private _itemTagHelperService: ItemTagHelperService
    , private _router: Router
    , private _location: Location
    , private _routerHelperService: RouterHelperService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _coreComService: CoreCOMService
    , private _eMenuService: EMenuService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _IOSHelperService: IOSHelperService
    , private _webShopService: WebShopService

    , private _accessibilityWebShopService: AccessibilityWebShopService
    , private _trackingManager: TrackingManager
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _benefitRedemptionService: BenefitRedemptionService
    , private _mainnavService: MainnavService
    , private _inHouseOrderService: InHouseOrderService
    , private _couponRedemptionService: CouponRedemptionService) {
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._shippingCartSubscriber) {
      me._shippingCartSubscriber.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._menuSettingSubscriber) {
      me._menuSettingSubscriber.unsubscribe();
    }
    if (me._productSubscriber) {
      me._productSubscriber.unsubscribe();
    }
    me._benefitRedemptionService.clearCachedBenefitData();
    if (me._isOpenedFromCoupon && !me._isCouponAttachedToCart) {
      me._couponRedemptionService.discardReservedCoupon()
        .catch(error => me._coreLogService.error("MenuDetailComponent.ngOnDestroy", "discardReservedCoupon", error));
    me._couponRedemptionService.clearBasketCouponRowMarker()
      .catch(error => me._coreLogService.error("MenuDetailComponent.ngOnDestroy", "clearBasketCouponRowMarker", error));
  }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuDetailComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** Menu visits stay bookable as normal items. */
  public get isCouponContext(): boolean {
    const me = this;
    return me._isOpenedFromBasketCouponRow && me._webShopService.getShippingCartItems().some(
      i => i.product_id === me.productId && !!i.coupon_id
    );
  }

  /** A coupon redeems exactly one item, so this page must not book a second one. */
  public get isCouponAddLocked(): boolean {
    const me = this;
    return me.isCouponContext || me._isCouponAttachedToCart;
  }

  public openInCartDialog(): void {
    const me = this;
    me._couponRedemptionService.openInCartDialog(() => me.PushChanges());
  }

  ngOnInit() {
    const me = this;
    me.isEMenu = me._eMenuService.isActive;
    me.currencySymbol = me._webShopService.currencySymbol;
    me.serviceId = me._webShopService.getServiceMode();
    me.voucherService = me._webShopService.voucherServiceType;
    me.getRouteData();
    me._isOpenedFromCoupon = me._couponRedemptionService.consumeCouponFlowNavigationMarker(me.productId);
    me.restoreCouponContextFromStorage();
    me.currentProductSettingIndex = 0;
    me.isOnline = me._coreComService.environment.networkInformation.isOnline;

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      if (me.use_item_annotation) {
        me.setAnnotationLabels(true);
      }
      me.PushChanges();
    });
    me.loadItemAnnotationSettings();
    me._menuSettingSubscriber = me._menuDetailService.MenuSettingObserveChanges.subscribe(() => {
      me.reloadDataAndRender(); // PushChanges wird intern aufgerufen
    });

    me._productSubscriber = me._menuDetailService.ProductObserveChanges.subscribe(() => {
      me.reloadDataAndRender(); // PushChanges wird intern aufgerufen
    });

    me.loadBenefitData();
    me.initializeSortAndFilterOption();

    me._webShopService.getWebshopSettingsDataModel().then(async (settings) => {
      me.webshopSettings = settings;
      me.includeDeposit = settings.deposit_view === DepositView.AddInArticlelist;
      if (settings.is_itemtag_enabled) {
        me.itemTags = await me._itemTagHelperService.GetProductTags();
        if (me.itemTags && me.itemTags.length > 0) {
          me.isItemTagEnabled = settings.is_itemtag_enabled;
          me.itemTagType = settings.itemtag_type;
        }
      }
      me.reloadDataAndRender(); // PushChanges wird intern aufgerufen
    });

    me._shippingCartSubscriber = me._webShopService.ShippingCartObserver.subscribe((shippingCartItems) => {
      if (shippingCartItems) {
        me.itemsInBasket = me._webShopService.getTotalCountOfItems();
        me.PushChanges();
      } else {
        me.itemsInBasket = 0;
        me.PushChanges();
      }
    });

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
  }

  public get isColorsEnabled(): boolean {
    return this._accessibilityWebShopService.isAccessabiltyColorsEnabled();
  }

  //in iOS: Delayed rendering so Button stays on bottom
  ngAfterViewInit(): void {
    const me = this;
    if (me._coreComService.environment.client.isMobile && me._coreComService.environment.client.type === ClientType.ios) {
      setTimeout(() => {
        me.showBuying = true;
        me.PushChanges();
      }, 200);
    } else {
      me.showBuying = true;
      me.PushChanges();
    }
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  public svgSanitizer(svg: string, color: string) {
    const me = this;
    return me._itemTagHelperService.svgSanitizer(svg, color);
  }

  /**
 * Set the title of the page by title Data in route data
 * This data has been set in RouterHelperService by each navigationEnd Event
 */
  private getRouteData() {
    const me = this;
    me.productId = +(me._activatedRoute.snapshot.paramMap.get("productId"));
    me.locationId = +(me._activatedRoute.snapshot.paramMap.get("locationId"));
    me.useBrowserHistory = me._activatedRoute.snapshot.data["useBrowserHistory"];
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["activeItemGroupId"]) {
      me.activeItemGroupId = routeTargetData["activeItemGroupId"];
    } else {
      me.activeItemGroupId = +(me._activatedRoute.snapshot.paramMap.get("activeItemGroupId"));
    }
  }

  /** Async fallback for a browser refresh — both in-memory markers reset on reload, so the persisted storage is re-checked. */
  private restoreCouponContextFromStorage(): void {
    const me = this;
    if (!me._isOpenedFromCoupon) {
      me._couponRedemptionService.getReservedCoupon().then((reservedCoupon) => {
        me._isOpenedFromCoupon = !!(reservedCoupon && reservedCoupon.productId === me.productId);
        me.PushChanges();
      });
    }
    me._couponRedemptionService.getBasketCouponRowProductId().then((markedProductId) => {
      me._isOpenedFromBasketCouponRow = markedProductId === me.productId;
      me.PushChanges();
    });
  }

  /**set sorting option and filter at the first loading of the page */
  private initializeSortAndFilterOption() {
    const me = this;
    // me.sortOption.push(me.pagingHelper.createSortOption("order", SortDirection.DESC));
  }

  public onImageError() {
    this.hasImage = false;
    this.PushChanges();
  }

  private loadItemAnnotationSettings() {
    const me = this;
    // global settings for annotation
    me._webShopService.getWebshopSettingsDataModel().then(webshopSettings => {
      // annotation settings for orderType
      if (webshopSettings && webshopSettings.use_item_annotation) {
        if (me._webShopService.ordertype && me._webShopService.ordertype.use_item_annotation) {
          me.use_item_annotation = true;
          me.setAnnotationLabels(true);
          me.PushChanges();
        }
      }
    }).catch(error => {
      me._coreLogService.error("menuDetail", "loadItemAnnotationSettings", error
      );
    });

  }

  private setAnnotationLabels(isAnnotationActivated: boolean) {
    const me = this;
    if (isAnnotationActivated) {
      me.annotationTitle = me._webShopService.ordertype.annotation_title;
      me.annotationPlaceholder = me._webShopService.ordertype.annotation_placeholder;
    }
  }

  private reloadDataAndRender() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();

    me._menuDetailService.GetProductDetailById(me.locationId, me.productId, me.itemTags)
      .then(async productDetail => {
        if (productDetail) {
          me.isAvailable = await me._webShopService.isProductAvailable$(productDetail.productId);
          me.productDetailViewModel = productDetail;
          me.headerGroupAdditives = productDetail.productHeaderGroups.find(group => group.id === MenuTab.Additives);
          me.headerGroupAllergies = productDetail.productHeaderGroups.find(group => group.id === MenuTab.Allergens);
          me.headerGroupCO2 = productDetail.productHeaderGroups.find(group => group.id === MenuTab.CO2);
          me.hasImage = (productDetail.imagePhoto !== "");
          if (productDetail.description) {
            me.hasDescriprion = productDetail.description !== "";
          }
          me.totalPrice = me.productDetailViewModel.price;
          const extraItemAsImage = (await me._menuDetailService.GetMenuSettings()).extra_as_image;
          if (productDetail.productExtras && productDetail.productExtras.length > 0) {
            me.choiceExtras = [];
            await Utils.asyncForEach(productDetail.productExtras, async (extra) => {
              const choiceExtra = new ChoiceExtra();
              choiceExtra.sortNr = extra.queryOrder;
              choiceExtra.label_de = extra.titleDE;
              choiceExtra.label_en = extra.titleEN;
              choiceExtra.max = (extra.maxChoices > 0) ? extra.maxChoices : 1;
              choiceExtra.min = (extra.forceMode) ? choiceExtra.max : 0;
              choiceExtra.showUpToNItems = 5;
              await Utils.asyncForEach(extra.productExtraItems, async (extraItem) => {
                if (extraItem.subIndex >= 0) {
                  let product: ProductDataModel4 = null;
                  if (extraItemAsImage) {
                    product = (await this._menuDetailService.GetProductDataByProductId(extraItem.product_id, false)).product;
                  }
                  const item = new ChoiceExtraItem(extraItem, product);
                  item.max = choiceExtra.max;
                  item.includeDeposit = me.includeDeposit;
                  item.isAvailable = item.subExtras && item.subExtras.length > 0 ? extraItem.isAvailable && item.subExtras.some(sub => sub.isAvailable) : extraItem.isAvailable;
                  item.setIsBenefitCallback(() => me.isBenefit);
                  // Subchoices
                  if (extraItem.subIndex > 0) {
                    await Utils.asyncForEach(extra.productExtraItems.filter(a => a.subIndex === -extraItem.subIndex), async (subExtra) => {
                      let subProduct: ProductDataModel4 = null;
                      if (extraItemAsImage) {
                        subProduct = (await this._menuDetailService.GetProductDataByProductId(subExtra.product_id, false)).product;
                      }
                      const subItem = new ChoiceExtraItem(subExtra, subProduct);
                      subItem.max = choiceExtra.max;
                      subItem.includeDeposit = me.includeDeposit;
                      subItem.isAvailable = item.isAvailable && subExtra.isAvailable;
                      subItem.setIsBenefitCallback(() => me.isBenefit);
                      item.subExtras.push(subItem);
                    });
                  }
                  choiceExtra.items.push(item);
                }
              });
              choiceExtra.countOfExtraOptions = choiceExtra.items.reduce((sum, item) => {
                return sum + (item.subExtras.length > 0 ? item.subExtras.length : 1);
              }, 0);

              const zeroChoices = (choiceExtra.countOfExtraOptions === 0);
              const oneForcedChoice = (choiceExtra.countOfExtraOptions === 1);
              choiceExtra.hasNoChoice = zeroChoices || oneForcedChoice;
              // Prefill if hasNoChoice
              if (choiceExtra.hasNoChoice && choiceExtra.items.length > 0) {
                const firstExtra = choiceExtra.items[0];
                const firstSubExtra = (firstExtra && (firstExtra.subExtras.length > 0)) ? firstExtra.subExtras[0] : null;
                me.incrementExtra(choiceExtra, firstExtra, firstSubExtra, choiceExtra.max);
              }
              choiceExtra.items.sort((a, b) => a.sortNr - b.sortNr);
              me.choiceExtras.push(choiceExtra);
            });
            me.choiceExtras.sort((a, b) => +b.hasNoChoice - +a.hasNoChoice || a.sortNr - b.sortNr);
          }
          me.hasData = true;
        } else {
          me.hasData = false;
        }
        me.PushChanges();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me.hasData = false;
        me.PushChanges();
        me._snackBarService.ShowErrorMessageFailed(61);
        me._coreLogService.error("MenuDetailComponent.reloadDataAndRender", "GetProductDetailById", e);
        me._overlaySpinnerService.HideLayoutSpinner();
      });
  }

  public get visibleExtragroups(): ChoiceExtra[] {
    return this.choiceExtras.filter(extragroup => !extragroup.hasNoChoice);
  }

  public canAddToCart(): boolean {
    const me = this;
    if (me._webShopService.getServiceMode() === WebShopMode.Webvoucher
      && me._webShopService.voucherServiceType === VoucherServiceType.Charge) {
      return true;
    }
    if (!me.isAvailable) {
      return false;
    }
    if (me.isChargeVoucher()) {
      if (me.parseVariablePriceInputValue() == null) {
        return false;
      } else {
        if (me.parseVariablePriceInputValue() < me.getVariablePriceMin() ||
          me.parseVariablePriceInputValue() > me.getVariablePriceMax()) {
          return false;
        }
      }
    }
    if (me.choiceExtras) {
      return !me.choiceExtras.find(choice => choice.count < choice.min);
    } else {
      me._coreLogService.error("MenuDetailComponent.canAddToCart", "Extra Choices are not defined");
    }
  }

  /**
 * Open a ModalDialog for rating a news or watching news rating info
 * @param news is empty if there is no rating yet. sending item Id and contentType to show rating data in modalDialog if user rate this item before.
 */
  public openRateModel(product: ProductDetailViewModel): void {
    const me = this;
    const ratingModel = me._bottomSheetHelperService.open(RatingDialogComponent, {
      data: { contentId: product.id, contentType: ContentType.sub_Product, title: product.label },
    });
    // show snackBar after rating Item
    ratingModel.afterDismissed().subscribe((result: Promise<RatingViewModel>) => {
      if (result) {
        result
          .then((ratingViewModel) => {
            me.productDetailViewModel.rate = ratingViewModel.rating;
            me.PushChanges();
            me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          })
          .catch(e => {
            me._coreLogService.error("MenuDetailComponent.openRateModel", "afterClosed", e);
            me._snackBarService.ShowErrorMessageFailed(62);
          });
      }
    });
  }

  // format price base on language
  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  public get hasBaseUnit(): boolean {
    const me = this;
    return me.productDetailViewModel.item_base_unit !== BaseUnit.NONE;
  }

  public get baseUnit(): string {
    const me = this;
    switch (me.productDetailViewModel.item_base_unit) {
      case BaseUnit.PIECE:
        return me.pricePerUnit + " / 1" + (InternationalisationService.locale === "de" ? "Stk" : "pc");
      case BaseUnit.LITER:
        return me.pricePerUnit + " / 1l";
      case BaseUnit.KILO:
        return me.pricePerUnit + " / 1kg";
      case BaseUnit.NONE:
        return "";
      default:
        me._coreLogService.error("MenuDetailComponent.baseUnit", "unknown item_base_unit", me.productDetailViewModel.item_base_unit);
        return "";
    }
  }

  /** Product price per unit */
  public get pricePerUnit(): string {
    const me = this;
    const pricePerUnit = Utils.pricePerUnit(me.getPriceWithExtras(), me.productDetailViewModel.item_base_factor);
    return me.priceFormatter(pricePerUnit);
  }

  /** Alcohol content */
  public get AlcohollevelText(): string {
    const me = this;
    return me._coreLanguageService.value("phProductDetail_Alcohol_Content")
      .replace("{value}", me.productDetailViewModel.item_alcohol.toString()) + " % Vol.";
  }
  /** Caffeine content */
  public get CaffeinelevelText(): string {
    const me = this;
    return me._coreLanguageService.value("phProductDetail_Caffeine_Content")
      .replace("{value}", me.productDetailViewModel.item_caffeine.toString()) + " mg";
  }

  public swipeRightHandler() {
    const me = this;
    if (me.currentProductSettingIndex > 0) {
      --me.currentProductSettingIndex;
      me.PushChanges();
    } else {
      me.SwiperNavigateBack();
    }
  }

  public swipeLeftHandler() {
    const me = this;
    if (me.currentProductSettingIndex < (me.productDetailViewModel.productHeaderGroups.length - 1)) {
      ++me.currentProductSettingIndex;
      me.PushChanges();
    }
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  public navigateBack(): void {
    const me = this;
    if (me.useBrowserHistory) {
      if (me._webShopService.getServiceMode() !== WebShopMode.Webvoucher) {
        me._routerHelperService.setRouteTargetDataByKey("activeItemGroupId", me.activeItemGroupId);
      }
      me._location.back();
    } else {
      if (me.serviceId === WebShopMode.Webvoucher) {
        me._webShopService.HasSingleLocation(me.serviceId)
          .then(response => {
            if (response) {
              if (me.webshopSettings.is_vouchercharge_enabled) {
                me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
                me._router.navigate(["/vouchercredit"], { replaceUrl: true });
              } else {
                me._router.navigate(["/menuservice"], { replaceUrl: true });
              }
            } else {
              me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
              me._router.navigate(["/menulocation"], { replaceUrl: true });
            }
          })
          .catch(e => {
            me._coreLogService.error("MenuDetailComponent.navigateBack", "_webShopService.HasSingleLocation", e);
            me._snackBarService.ShowErrorMessageFailed(63);
          });
      } else {
        me._routerHelperService.setRouteTargetDataByKey("activeItemGroupId", me.activeItemGroupId);
        me._location.back();
      }
    }
  }

  private loadBenefitData() {
    const me = this;
    me.getCachedBenefitData().then(data => {
      if (data) {
        me.isBenefit = me._webShopService.isBenefitItem(data.benefitLossId, data.bonusactionId, data.benefitId);
        me.benfitCostPoints = data.benefitCostPoints;
        me.PushChanges();
      }
    }).catch(() => {
      me._coreLogService.error("MenuDetailComponent.loadBenefitData", "getCachedBenefitData",);
    });
  }

  private async getCachedBenefitData(): Promise<IBenefitCacheEntry> {
    const me = this;
    const benefitData = await me._benefitRedemptionService.getCachedBenefitData();
    return benefitData ? benefitData : null;
  }

  private clearBenefitCacheAfterAction() {
    const me = this;
    const validOrderType = me.serviceId === WebShopMode.TakeAway || me.serviceId === WebShopMode.Delivery
      || me.serviceId === WebShopMode.OrderToTable || me.serviceId === WebShopMode.Retail;
    if (validOrderType && me.isBenefit) {
      me._benefitRedemptionService.clearCachedBenefitData().then(() => {
        me.isBenefit = false;
        me.PushChanges();
      })
    }
  }

  /** Verifie if the product to be added is a charge voucher.
   * If so, check conditions and open a dialog.
   * Otherwise, add the product to the basket.
   * @param amount - The amount of the product to be added.
   * @param event - Triggered by the user action.
   */
  public verifyAndAddproductToBasket(amount: number, event: MouseEvent) {
    const me = this;
    const handleChargeVoucher = me._verifyChargeVoucherItem();
    if (handleChargeVoucher) {
      me._manageVoucherChargeOption(event);
    } else {
      if (me.isRemoteOrderGroup) {
        let finishing = false;
        me._remoteGroupOrderService.groupStatusPaymentStarted$.pipe(take(1)).subscribe(value => finishing = value).unsubscribe();
        finishing ? me._remoteGroupOrderService.notifyPaymentStarted() : me.addProductToBasket(amount, event);
      } else {
        me.addProductToBasket(amount, event);
      }

    }
  }

  //#region IH-GROUP

  /**
   * Processes InHouse Group Order workflow*/
  private async processInHouseGroupOrder(amount: number, event: MouseEvent): Promise<void> {
    const me = this;
    // Check AGB acceptance
    if (!me._webShopService.hasAcceptedAGB) {
      const agbResult = await me._openAGBConfirmationDialog();
      if (agbResult !== AGBConfirmationDialogResult.Accepted) {
        return;
      }
    }
    //Ensure notification is set
    const notificationSet = await me._inHouseOrderService.ensureNotificationIsSet(
      me.isInHouseGroupOrder,
      () => me._overlaySpinnerService.ShowLayoutSpinner(),
      () => me._overlaySpinnerService.HideLayoutSpinner()
    );
    if (!notificationSet) {
      me._snackBarService.ShowErrorMessageFailed(AppErrorCode.MENU_DETAIL_NOTIFICATION_SETUP_FAILED);
      return;
    }
    const { extras, selectedExtras } = me.extrasConfiguration();
    const config = await me.buildProductConfiguration(amount, extras);
    me.IHGroupOrderOpenContinueShoppingDialog(amount, selectedExtras)
      .subscribe(async (result: IContinueShoppingDialogResult) => {
        if (result) {
          config.comment = result.comment ? result.comment : "";
          me._handleInHouseGroupAction(result.action, event, config);
        } else {
          me._setDefaultSelection();
          me._scrollIntoView();
        }
      });
  }

  /** Handles the action after item was added to basket */
  private async _handleInHouseGroupAction(action: ContinueShoppingAction, event: MouseEvent, config: ProductConfiguration): Promise<void> {
    const me = this;
    if (action === ContinueShoppingAction.AddToGroupBasket) {
      try {
        const success = await me._webShopService.addItemToIHGroupBasketAndCheckAge(me.locationId, me.productId, config);
        if (success) {
          me.animateParticleToBasket(event.pageX, event.pageY);
          me.buyAmount = 1;
          me.PushChanges();
          me._router.navigate(["/menu", me.activeItemGroupId]);
        }
      } catch (error) {
        me._coreLogService.error("MenuDetailComponent._handleInHouseGroupAction", "addItemToShippingCartAndCheckAge", error);
        me._snackBarService.ShowErrorMessageFailed(AppErrorCode.ADD_ITEM_TO_IHGROUP_BASKET_FAILED);
        me._router.navigate(["/menugroup"]);
      }

    } else if (action === ContinueShoppingAction.OrderDirectly) {
      try {
        const success = await me._webShopService.addItemToIHUserBasket(me.locationId, me.productId, config);
        if (success) {
          me.animateParticleToBasket(event.pageX, event.pageY);
          me.buyAmount = 1;
          me.clearBenefitCacheAfterAction();
          me.PushChanges();
          await me._orderInhouseDirectly();
        }
      } catch (error) {
        me._coreLogService.error("MenuDetailComponent._handleInHouseGroupAction", "OrderDirectly failed", error);
        me._snackBarService.ShowErrorMessageFailed(AppErrorCode.IHGROUP_ORDER_DIRECTLY_TECHNICAL_ERROR);
      }

    } else if (action === ContinueShoppingAction.Overview) {
      me._router.navigate(["/groupOrderOverview"]);

    } else {
      // user cancelled, do nothing
    }
  }

  /** Opens AGB Confirmation Dialog and returns the result */
  private async _orderInhouseDirectly(): Promise<void> {
    const me = this;
    const request: req_Order = {
      order_type: OrderType.UserBasket,
    };
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._inHouseOrderService.Order(request);
      me._overlaySpinnerService.HideLayoutSpinner();
      if (response.status === OrderStatus.Okay) {
        me._router.navigate(["/inHauseOrderConfirm"]);
      } else {
        me._coreLogService.error("MenuDetailComponent._orderInhouseDirectly", "Order status not Okay", response.status);
        me._snackBarService.ShowErrorMessageFailed(AppErrorCode.IHGROUP_ORDER_DIRECTLY_STATUS_NOT_OKAY);
      }
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("MenuDetailComponent._orderInhouseDirectly", "Order catch", error);
      me._snackBarService.ShowErrorMessageFailed(AppErrorCode.IHGROUP_ORDER_DIRECTLY_TECHNICAL_ERROR);
    }
  }

  //#endregion IH-GROUP

  public async addProductToBasket(amount: number, event: MouseEvent): Promise<void> {
    const me = this;
    if (!me.productDetailViewModel || me._isAddingProductToBasket) {
      return;
    }
    me._isAddingProductToBasket = true;
    try {
      // InHouse Group Order workflow
      if (me.isInHouseGroupOrder) {
        await me.processInHouseGroupOrder(amount, event);
        return;
      }
      if (me._isOpenedFromCoupon) {
        const reservedCoupon = await me._couponRedemptionService.getReservedCoupon();
        if (!reservedCoupon) {
          me._couponRedemptionService.openNotAvailableDialog(() => me.PushChanges());
          return;
        }
        amount = 1;
      }
        const { extras, selectedExtras } = me.extrasConfiguration();
        const config = await me.buildProductConfiguration(amount, extras);
        try {
          let showContinueShoppingDialog: boolean = false;
          const success = await me._webShopService.addItemToShippingCartAndCheckAge(me.locationId, me.productId, config)
          if (success) {
          if (me._isOpenedFromCoupon) {
            await me._couponRedemptionService.discardReservedCoupon();
            me._isCouponAttachedToCart = true;
          }
            me.animateParticleToBasket(event.pageX, event.pageY);
            me.buyAmount = 1;
            showContinueShoppingDialog = success;
            me.PushChanges();
            me.trackAddToCart(amount);
          }
          let isTicket = me._webShopService.getServiceMode() === WebShopMode.Ticket;
          if (isTicket) {
            showContinueShoppingDialog = me._webShopService.ordertype && me._webShopService.ordertype.model.multi_selection
          }
          if (me.isRemoteOrderGroup) {
            await me._remoteGroupOrderService.addArticle({ ID: this.productDetailViewModel.id, Count: amount }, extras, config.comment);
            me.OpenRemoteGroupContinueOrderDialog(selectedExtras, amount);
          } else {
            if (showContinueShoppingDialog) {
              me.OpenContinueShoppingDialog(selectedExtras, amount)
            }
          }

        } catch (error) {
          me._coreLogService.error("MenuDetailComponent.addProductToBasket", "_webShopService.addItemToShippingCartAndCheckAge", error);
          me._snackBarService.ShowErrorMessageFailed(64);
          // zurück in die warengruppe
          if (me._webShopService.getServiceMode() !== WebShopMode.Webvoucher) {
            me._router.navigate(["/menugroup"]);
          } // else bei Webgutschein auf der Seite bleiben (da es keine menugroup für gutscheine gibt)
        }
    } finally {
      me._isAddingProductToBasket = false;
      }
    }

  private extrasConfiguration() {
    const extras: ProductConfigurationExtra[] = [];
    const selectedExtras: IExtraItemConfig[] = [];
    for (const extra of this.choiceExtras) {
      for (const extraItem of extra.items) {
        if (extraItem.count > 0) {
          extras.push({ id: extraItem.id, count: extraItem.count });
          selectedExtras.push({
            id: extraItem.id,
            label: extraItem.label,
            count: extraItem.count,
            subIndex: extraItem.subIndex
          });

          for (const subExtraItem of extraItem.subExtras) {
            if (subExtraItem.count > 0) {
              extras.push({ id: subExtraItem.id, count: subExtraItem.count });
              selectedExtras.push({
                id: subExtraItem.id,
                label: subExtraItem.label,
                count: subExtraItem.count,
                subIndex: subExtraItem.subIndex
              });
            }
          }
        }
      }
    }
    return { extras, selectedExtras };
  }

  private async buildProductConfiguration(amount: number, extras: ProductConfigurationExtra[]): Promise<ProductConfiguration | null> {
    const me = this;
    const benefitData = await me.getCachedBenefitData();
    const config: ProductConfiguration = { extras, count: amount, benefitData: benefitData ? benefitData : null, comment: this.itemAnnotationText ? this.itemAnnotationText : "" };
    if (me.isChargeVoucher) {
      const parsedVariablePrice = me.parseVariablePriceInputValue();
      if (parsedVariablePrice != null) {
        config.variable_price = parsedVariablePrice;
      } else {
        me._coreLogService.error("MenuDetailComponent.addProductToBasket", "Variable Price is not parseable");
        return null;
      }
    }
    if (me._isOpenedFromCoupon) {
      const reservedCoupon = await me._couponRedemptionService.getReservedCoupon();
      if (reservedCoupon) {
        config.couponData = reservedCoupon;
      } else {
        me._coreLogService.error("MenuDetailComponent.buildProductConfiguration", "coupon flow active but no reserved coupon found", me.productId);
      }
    }
    return config;
  }

  private buildBaseItemConfig(amount: number, selectedExtras: IExtraItemConfig[]): IItemConfig {
    return {
      id: this.productDetailViewModel.id,
      image: this.productDetailViewModel.imagePhoto,
      label: this.productDetailViewModel.label,
      price: this.getTotalPrice(),
      count: amount,
      extras: selectedExtras,
      itemGroupId: this.activeItemGroupId,
      isBenefit: this.isBenefit,
      benefitCostPoints: this.benfitCostPoints,
      comment: this.itemAnnotationText ? this.itemAnnotationText : "",
    };
  }

  private trackAddToCart(amount: number): void {
    if (!this.productId || amount <= 0 || !this.totalPrice) return;
    this._trackingManager.trackAddToCart(
      this.productId,
      this.productDetailViewModel.labelDE,
      amount,
      this.totalPrice,
      this.currencySymbol,
      this._webShopService.getBasketSumTotal(),
      this.getShoppingCartItemsIDs()
    );
  }

  private getShoppingCartItemsIDs(): number[] {
    return this._webShopService.getShippingCartItems().map(item => item.product_id);
  }

  /** Checks if the item is a charge voucher and if there are items in the cart.
   * @returns  True if both conditions are met, false otherwise.*/
  private _verifyChargeVoucherItem() {
    const me = this;
    const isChargeVoucher = me.isChargeVoucher();
    if (isChargeVoucher) {
      const hasItemsInBasket = me._webShopService.shippingCartItems && me._webShopService.shippingCartItems.length > 0;
      return hasItemsInBasket;
    }
  }

  /** The information text for changing the charge voucher amount*/
  private _setTextChangeChargeAmount() {
    let currentAmount: number;
    const me = this;
    let newAmount: number = parseInt(me.variablePriceInputValue, 10)
    me._webShopService.getShippingCartItems().filter((item => {
      currentAmount = item.variable_price;
    }))
    const changeVoucherAmountInfoLabel = me._coreLanguageService.value("phChargeVoucherDialog_Change_Price_Info")
      .replace("{currentAmount}", me.priceFormatter(currentAmount)).replace("{newAmount}", me.priceFormatter(newAmount));
    return changeVoucherAmountInfoLabel;
  }

  //#region Dialogs

  /**
   * Opens AGB confirmation dialog with support for term links
   * If user clicks on a term link, closes AGB, opens term, then reopens AGB
   * @returns Promise with user's final decision
   */
  private async _openAGBConfirmationDialog(): Promise<AGBConfirmationDialogResult> {
    const me = this;
    const dialogRef = me._bottomSheetHelperService.open(AGBConfirmationDialogComponent, {
      panelClass: "mat-bottom-sheet-container-medium"
    });
    const result = await dialogRef.afterDismissed().toPromise();
    if (result && result.result === AGBConfirmationDialogResult.OpenTerm && result.termId) {
      const termDialog = me._bottomSheetHelperService.open(TermDialogComponent, {
        data: result.termId,
        panelClass: "mat-bottom-sheet-container--full-height"
      });
      await termDialog.afterDismissed().toPromise();
      // reopen AGB dialog
      return await me._openAGBConfirmationDialog();
    }
    if (result && result.result) {
      return result.result;
    }
    // default to Denied
    return AGBConfirmationDialogResult.Denied;
  }

  /**The dialog to change the charge amount or retain the current amount */
  private _manageVoucherChargeOption(event: MouseEvent) {
    const me = this;
    const dialogref = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phChargeVoucherDialog_Change_Price_Title"
        , content: me._setTextChangeChargeAmount()
        , firstBtnLabel: "phChargeVoucherDialog_Change_Price_Confirm"
        , secondBtnLabel: "phChargeVoucherDialog_Change_Price_Decline"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    dialogref.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._webShopService.shippingCartItems.filter((item) => {
          me._webShopService.removeCountItem(item).then((_) => {
            me.addProductToBasket(1, event)
          })
        });
      } else if (result === AnounceModalResult.SecondButton) {
        // Do nothing
      } else {
        //Do nothing
      }
    });
  }

  public openAnnounceDialog() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phProductDetail_Announce_Dialog_Title"
        , content: "phProductDetail_Announce_Dialog_Content"
        , firstBtnLabel: "phProductDetail_Announce_Dialog_FirstBtn_Label"
        , secondBtnLabel: "phProductDetail_Announce_Dialog_SecondBtn_Label"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._router.navigate(["/menuservice"]);
      } else if (result === AnounceModalResult.SecondButton) {
        // Do Nothing
      } else {
        // nothing
      }
    });
  }

  public OpenContinueShoppingDialog(selectedExtras: IExtraItemConfig[], amount: number) {
    const me = this;
    const dialogData: IItemConfigurationData = {
      itemConfig: {
        ...me.buildBaseItemConfig(amount, selectedExtras),
        isWebVoucher: false,
        isTicket: me._webShopService.getServiceMode() === WebShopMode.Ticket,
      },
      isInhOuseGroupOrder: false,
    };
    const bottomSheetRef = me._bottomSheetHelperService.open(ContinueShoppingDialogComponent, {
      data: dialogData,
      panelClass: "mat-bottom-sheet-container-medium"
    });
    bottomSheetRef.afterDismissed().subscribe((result) => {
      me._setDefaultSelection();
      me.clearBenefitCacheAfterAction();
      if (!result || result === 'undefined') {
        me._scrollIntoView();
        me.PushChanges();
      }
    })
  }

  private IHGroupOrderOpenContinueShoppingDialog(amount: number, selectedExtras: IExtraItemConfig[]) {
    const me = this;
    const dialogData: IItemConfigurationData = {
      itemConfig: {
        ...this.buildBaseItemConfig(amount, selectedExtras),
        isWebVoucher: false,
        canComment: me.webshopSettings.use_item_annotation,
      },
      isInhOuseGroupOrder: true,
    };
    const bottomSheetRef = me._bottomSheetHelperService.open(ContinueShoppingDialogComponent, {
      data: dialogData,
      panelClass: "mat-bottom-sheet-container-medium"
    });
    return bottomSheetRef.afterDismissed();
  }

  /**
 * Opens the Remote Group Continue Order dialog with the specified item configuration.
 * User can set 'Ready' state
 * @param {ExtraItemConfig[]} selectedExtras - The selected extra items to include in the order.
 * @param {number} amount - The quantity of the item to be ordered.
 */
  public OpenRemoteGroupContinueOrderDialog(selectedExtras: IExtraItemConfig[], amount: number) {
    const me = this;
    const itemConfig: IItemConfig = {
      ...me.buildBaseItemConfig(amount, selectedExtras),
      canComment: me.webshopSettings.use_item_annotation,
    }
    const bottomSheetRef = me._bottomSheetHelperService.open(RemoteGroupContinueOrderDialogComponent, {
      data: itemConfig,
    });
    bottomSheetRef.afterDismissed().subscribe(() => {
      me._setDefaultSelection();
      me._scrollIntoView();
    })
  }

  // endregion Dialogs

  private _setDefaultSelection() {
    const me = this;
    const hasExtras = me.visibleExtragroups && me.visibleExtragroups.length > 0;
    if (hasExtras) {
      for (const extra of me.visibleExtragroups) {
        for (const extraItem of extra.items) {
          if (extraItem.subExtras && extraItem.subExtras.length > 0) {
            for (const subExtraItem of extraItem.subExtras) {
              subExtraItem.count > 0 ? subExtraItem.count = 0 : "";
            }
          }
          extraItem.count > 0 ? extraItem.count = 0 : "";
        }
        extra.count > 0 ? extra.count = 0 : "";
      }
    }
  }

  public incrementExtra(extra: ChoiceExtra, item: ChoiceExtraItem, subItem: ChoiceExtraItem, amount: number = 1) {
    if (subItem && subItem.count >= subItem.max) { return; }
    if (extra.count + amount <= extra.max && item.count + amount <= item.max) {
      item.count += amount;
      if (subItem) {
        subItem.count += amount;
      }
      extra.count += amount;
    }
    this.PushChanges();
  }

  public decrementExtra(extra: ChoiceExtra, item: ChoiceExtraItem, subItem: ChoiceExtraItem, amount: number = 1) {
    if (subItem && subItem.count <= 0) { return; }
    if (extra.count - amount >= 0 && item.count - amount >= 0) {
      item.count -= amount;
      if (subItem) {
        subItem.count -= amount;
      }
      extra.count -= amount;
    }
    this.PushChanges();
  }

  public expandExtra(extra: ChoiceExtra) {
    if (extra.showUpToNItems === extra.items.length) {
      extra.showUpToNItems = 5; // Collapse the items
    } else {
      extra.showUpToNItems = extra.items.length; // Expand the items
    }
    this.PushChanges();
  }

  /** open dialog that displays additional information
   * @param productExtra
   */
  public openAddidtionInformationDialog(productExtra: ProductExtraItemViewModel) {
    const me = this;
    me._bottomSheetHelperService.open(ExtraAdditionalInfoDialogComponent, { data: productExtra })
  }

  /**
   * Allows for single and multiple selection when an item is clicked
   * @param extra represents the query
   * @param item represents an item of the query
   * @param subItem represents a subcategory of an item in a query
   */
  public onItemClick(extra: ChoiceExtra, item: ChoiceExtraItem, subItem: ChoiceExtraItem = null) {
    this.selectSingleExtra(extra, item, subItem);
  }

  /**
   * toggle selected extra item
   * increment or decrement count depending on selection
   * @param extra
   * @param item
   * @param subItem
   */
  public selectSingleExtra(extra: ChoiceExtra, item: ChoiceExtraItem, subItem: ChoiceExtraItem = null) {
    const me = this;
    const canIncrementItem = (item.count === 0 || (subItem && subItem.count === 0));
    // check if an item in a query can be selected
    if (canIncrementItem) {
      const extraMaxCountReached = extra.count === extra.max;
      // check if all possible items in a query are selected
      if (extraMaxCountReached) {
        // Decrement first selected query to allow selection again
        const selectedExtraItem = extra.items.find(i => i.count > 0);
        const selectedSub = selectedExtraItem.subExtras.find(i => i.count > 0);
        me.decrementExtra(extra, selectedExtraItem, selectedSub, 1);
      }
      me.incrementExtra(extra, item, subItem);
    } else {
      me.decrementExtra(extra, item, subItem, subItem ? subItem.count : item.count);
    }
  }

  /** Determines if the base price should be displayed */
  public showBasePrice(extraItem: ChoiceExtraItem): boolean {
    const baseUnit = extraItem.productDetails.item_base_unit_id;
    // No base price if the unit is set to None
    if (baseUnit === BaseUnit.NONE) {
      return false;
    }
    const itemBaseFactor = extraItem.productDetails.item_base_factor;
    // No base price if the unit is 1, e.g., 1 liter (no recalculation required by the customer)
    if (itemBaseFactor === 1) {
      return false;
    }
    const basePrice = extraItem.price;
    // No base price if the price is 0.00 €
    if (basePrice <= 0) {
      return false;
    }
    // Show base price if the 'itemBaseFactor' is e.g. 250 gr., 0.75 l
    return true;
  }

  /** Extra item deposit information*/
  public extraitemDepositInfo(extraItem: ChoiceExtraItem): string {
    const me = this;
    const deposit = me.priceFormatter(extraItem.deposit);
    return extraItem.includeDeposit ? me._coreLanguageService.value("phProductDetail_includeDeposit").replace("{deposit}", deposit) :
      me._coreLanguageService.value("phProductDetail_plusDeposit").replace("{deposit}", deposit)
  }

  public getExtraItemBaseUnit(extraitem: ChoiceExtraItem): string {
    const baseunitID = extraitem.productDetails.item_base_unit_id;
    let extraPrice = extraitem.price;
    // Calculate extra price if subExtras exist
    if (extraitem.subExtras.length > 0) {
      extraPrice += extraitem.subExtras.reduce((total, item) =>
        total + item.count * item.price +
        item.subExtras.reduce((subTotal, subItem) => subTotal + (subItem.count * subItem.price), 0),
        0);
    }
    const pricePerUnit = this.priceFormatter(Utils.pricePerUnit(extraitem.price, extraitem.productDetails.item_base_factor));
    switch (baseunitID) {
      case BaseUnit.PIECE:
        return `${pricePerUnit} / 1${InternationalisationService.locale === "de" ? "Stk" : "pc"}`;
      case BaseUnit.LITER:
        return `${pricePerUnit} / 1l`;
      case BaseUnit.KILO:
        return `${pricePerUnit} / 1kg`;
      case BaseUnit.NONE:
        return "";
      default:
        this._coreLogService.error(
          "MenuDetailComponent.baseUnit",
          "unknown item_base_unit",
          this.productDetailViewModel.item_base_unit
        );
        return "";
    }

  }

  public hasDepositPrice(): boolean {
    const me = this;
    return me.depositPrice() > 0;
  }

  /** ermittelt den allgemein enthaltenen Pfand */
  private depositPrice(): number {
    const me = this;
    let deposit = me.productDetailViewModel.deposit;
    me.choiceExtras.forEach(extra => {
      extra.items.forEach(item => {
        deposit += item.count * item.deposit;
        item.subExtras.forEach(subItem => {
          deposit += subItem.count * subItem.deposit;
        });
      });
    });
    return deposit;
  }

  /** Pfand information */
  public depositInfo(): string {
    const me = this;
    const deposit = me.priceFormatter(me.depositPrice() * me.buyAmount);
    return me.includeDeposit ? me._coreLanguageService.value("phProductDetail_includeDeposit").replace("{deposit}", deposit) :
      me._coreLanguageService.value("phProductDetail_plusDeposit").replace("{deposit}", deposit)
  }

  public getTotalPrice(): number {
    const me = this;
    const basePriceWithExtras = me.getPriceWithExtras();
    const inclDeposit = me.includeDeposit ? me.productDetailViewModel.deposit : 0;
    const variablePrice = me.isChargeVoucher ? me.parseVariablePriceInputValue() || 0 : 0;
    return (basePriceWithExtras + inclDeposit + variablePrice) * me.buyAmount;
  }

  private getPriceWithExtras(): number {
    const me = this;
    const basePrice = me.productDetailViewModel.basePrice;
    let extraPrice = 0;
    me.choiceExtras.forEach(extra => {
      extra.items.forEach(item => {
        extraPrice += item.count * item.price; // price already includes deposit
        item.subExtras.forEach(subItem => {
          extraPrice += subItem.count * subItem.price; // price already includes deposit
        });
      });
    });
    return (basePrice + extraPrice);
  }

  private benefitCostPoints(): string {
    const me = this;
    const cost = me.benfitCostPoints.toString();
    return me._coreLanguageService.value("phBenefit_Redeem_Cost_Points_Info").replace("{points}", cost);
  }

  public displayItemPrice(): string {
    const me = this;
    if (me.isBenefit) {
      return me.benefitCostPoints();
    } else {
      return me.priceFormatter(me.getTotalPrice());
    }
  }

  public isWebvoucher() {
    return this.productDetailViewModel.usingtype === UsingType.Webvoucher;
  }

  /** Determines if the product is a charge voucher.
   * A charge voucher has a using type of 'Webvoucher' and a price of 0.*/
  public isChargeVoucher() {
    const me = this;
    return me.isWebvoucher() && this.productDetailViewModel.price === 0;
  }

  public getVariablePriceMin() {
    return 1;
  }

  public getVariablePriceMax() {
    return 3000;
  }

  // region tab handling

  /**Tab group for product information */
  public GroupTabs(menuTabId: number) {
    const informationTabs = [MenuTab.Additives, MenuTab.Allergens, MenuTab.CO2, MenuTab.ECommerce];
    return informationTabs.includes(menuTabId);
  }

  /**
   * Checks if the ID of a tab group is valid based on specific rules
   * @param tabID
   * @param index
   * @returns boolean
   */
  public ValidateTabs(tabID: number, index: number) {
    const me = this;
    const previousTabId = (index - 1) > 0 ? me.productDetailViewModel.productHeaderGroups[index - 1].id : null;
    const group = [MenuTab.Additives, MenuTab.Allergens, MenuTab.ECommerce];
    return !group.includes(tabID) ||
      (tabID === MenuTab.Additives && previousTabId !== MenuTab.CO2) ||
      (tabID === MenuTab.Allergens && ![MenuTab.Additives, MenuTab.CO2].includes(previousTabId)) ||
      (tabID === MenuTab.ECommerce && ![MenuTab.Additives, MenuTab.Allergens, MenuTab.CO2].includes(previousTabId));
  }

  /** Verify the Information in the Product Tab */
  public VerifyTabContent(productDetail: ProductDetailViewModel): boolean {
    const me = this;
    const hasAdditives = me.headerGroupAdditives && me.headerGroupAdditives.content.length > 0;
    const hasAllergens = me.headerGroupAllergies && me.headerGroupAllergies.content.length > 0;
    const hasCO2Info = !Utils.IsNull(me.headerGroupCO2) ? !Utils.IsNull(me.headerGroupCO2.id) : false;
    const useEcommerce = productDetail.use_eCommerce;
    const hasItemContent = productDetail.hasItemContent;
    const hasProviderInfo = productDetail.hasItemProviderName || productDetail.hasItemProviderAddr;
    return (hasAdditives || hasAllergens || hasCO2Info || useEcommerce && (hasItemContent || hasProviderInfo))
  }

  /**set tab labels */
  public setpageTabLabel(headerGroupId: number): string {
    const me = this;
    const productHeaderGroup = me.productDetailViewModel.productHeaderGroups.find(p => p.id === headerGroupId);
    const groupTab = me.GroupTabs(headerGroupId);
    if (groupTab) {
      return me._coreLanguageService.value('phProductDetail_Labelling');
    } else {
      return productHeaderGroup.label;
    }
  }

  // endregion tab handling

  public onInputVariablePriceChange() {
    const me = this;
    if (me.variablePriceInputValue.length > 0) {
      const parsedValue = Utils.moneyRound(+(me.variablePriceInputValue.replace(",", ".")));
      if (parsedValue >= me.getVariablePriceMin()) {
        if (parsedValue >= me.getVariablePriceMax()) {
          me.variablePriceInputValue = me._webShopService.formatCurrency(me.getVariablePriceMax(), false, false);
        }
      } else {
        me.variablePriceInputValue = me._webShopService.formatCurrency(me.getVariablePriceMin(), false, false);
      }
    }
    me.PushChanges();
  }

  public onInputVariablePriceBlur() {
    const me = this;
    if (me.variablePriceInputValue.length > 0) {
      const parsedValue = Utils.moneyRound(+(me.variablePriceInputValue.replace(",", ".")));
      if (parsedValue > 0) {
        me.variablePriceInputValue = me._webShopService.formatCurrency(parsedValue, false, false);
      } else {
        me.variablePriceInputValue = me._webShopService.formatCurrency(0, false, false);
      }
    }
    me.PushChanges();
    me.setWebView();
  }

  public isNumberKey(event) {
    const me = this;
    const isDeutsch = me._coreLanguageService.getCurrentLanguage() === "de";
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 13) {
      event.target.blur();
    } else {
      if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (isDeutsch && charCode === 44) {// accept ',' for deutsch language
          // do nothink
        } else {
          return false;
        }
      }
    }

    const regexp = isDeutsch ? /^[+-]?(?=.?\d)\d*(\,\d{0,2})?$/ : /^[+-]?(?=.?\d)\d*(\.\d{0,2})?$/;
    if (regexp.test(event.target.value.slice(0, event.target.selectionStart) + event.key + event.target.value.slice(event.target.selectionStart))) {
      return true;
    } else {
      return false;
    }
  }

  public parseVariablePriceInputValue(): number | null {
    const parse = Utils.moneyRound(+(this.variablePriceInputValue.replace(",", ".")));
    if (parse >= 0) {
      return parse;
    } else {
      return null;
    }
  }

  //region view helpers

  /** Handle blur event */
  public onBlur(comment: string): void {
    const me = this;

    if (comment && !comment.trim()) {
      return;
    }
    // Update the comment
    if (this.itemAnnotationText !== comment) {
      this.itemAnnotationText = comment;
      me.PushChanges();
    }
  }

  /**solve problem for IOS keyboard. set the page size after closing the keyboard */
  public setWebView() {
    const me = this;
    me._IOSHelperService.setWebviewAfterBlur();
  }

  private _scrollIntoView() {
    const me = this;
    if (me.isSmallView) {
      document.getElementById("detailList").scrollIntoView({
        behavior: "smooth"
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  private animateParticleToBasket(x: number, y: number) {
    setTimeout(() => {
      const basketIcon = document.getElementById("header-icon-basket");
      if (basketIcon) {
        const basketRect = basketIcon.getBoundingClientRect();
        const dx = basketRect.left;
        const dy = basketRect.bottom;
        const particle = document.createElement("particle");
        particle.className = "addtobasket";
        document.body.appendChild(particle);
        const animation = particle.animate([
          {
            transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
            opacity: 1
          },
          {
            offset: 0.9,
            transform: `translate(${x + (dx - x) * 0.9}px, ${y + (dy - y) * 0.9}px)`,
            opacity: 1
          },
          {
            transform: `translate(${dx}px, ${dy}px)`,
            opacity: 0
          }
        ], {
          duration: 1000,
          easing: "cubic-bezier(0, .9, .6, 1)",
          delay: 0
        });
        animation.onfinish = () => {
          particle.remove();
        };
      }
    }, 50);
  }

  // endregion view helpers
}
